<!--
	메뉴경로 : 기준정보관리
 -->

<template>
  <select :disabled="this.disabled">
    <option v-if="this.required === null || this.noLabel != null" value="">{{ this.noLabel != null ? this.noLabel : "선택" }}</option>
    <option v-for="option in this.$store.getters.getCd(this.upCd)" :key="option.cd" :value="option.cd" :data-cd-label="option.cdNm" :selected="option.cd == cd">{{option.cdNm}}</option>
  </select>
</template>

<script>
// import mgrCdApi from "@/api/mgr/admin_mgrCdMng";
export default {
  data() {
    return {
      // optionList : [],
    }
  },
  props: ["upCd", "cd", "required", "noLabel", "disabled", "floatingLabel", "htmlSelect"],
  created() {
    // this.$store.dispatch("setCd", this.upCd);
    // this.optionList = this.$store.state.cdList[this.upCd];

    // 여기서 selectbox의 option data가져와서 this.optionList에 바인딩 시켜줌
    // mgrCdApi.listMgrCdMng({params: {
    //     page: 1,
    //     pageSize : 99999,
    //     searchKey: 'upCd',
    //     searchValue: this.upCd,
    //     useSttus: 1,
    //   }})
    //   .then((response) => {
    //      response.data.data.content;
    //   })
    //   .catch((error) => console.log(error))

  }
}
</script>
